// extracted by mini-css-extract-plugin
module.exports = {"folder-description":"cSeJc","folderDescription":"cSeJc"};